module.exports = __webpack_public_path__ + "img/music-note-terrarium-1.136b7472.jpg";